"use client";

import { c as _c } from "react/compiler-runtime";
import type { ProductCollectionSortItem, ProductSortItem } from "@repo/graphql-shopify-storefront";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { RefineByListItem } from "#/components/molecules/search-refinements/refine-by-list-item";
export function RefineBySortByQueryParameterItem(t0) {
  const $ = _c(23);
  const {
    item
  } = t0;
  const pathname = usePathname();
  const currentSearchParams = useSearchParams();
  const [active, setActive] = useState(currentSearchParams?.get("sort") === item.slug);
  let t1;
  let t2;
  if ($[0] !== currentSearchParams || $[1] !== item.slug) {
    t1 = () => {
      setActive(currentSearchParams?.get("sort") === item.slug);
    };
    t2 = [currentSearchParams, item.slug];
    $[0] = currentSearchParams;
    $[1] = item.slug;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  let title;
  if ($[4] !== active || $[5] !== currentSearchParams || $[6] !== item.slug || $[7] !== item.title || $[8] !== pathname) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const searchParams = new URLSearchParams(currentSearchParams);
      if (item.slug) {
        searchParams.set("sort", item.slug);
      }
      title = item.title;
      if (!pathname) {
        t6 = null;
        break bb0;
      }
      T0 = RefineByListItem;
      t5 = active;
      t3 = pathname;
      t4 = searchParams.toString();
    }
    $[4] = active;
    $[5] = currentSearchParams;
    $[6] = item.slug;
    $[7] = item.title;
    $[8] = pathname;
    $[9] = T0;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = title;
  } else {
    T0 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    title = $[14];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t4) {
    t7 = {
      pathname: t3,
      search: t4
    };
    $[15] = t3;
    $[16] = t4;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== T0 || $[19] !== t5 || $[20] !== t7 || $[21] !== title) {
    t8 = <T0 active={t5} href={t7} title={title} />;
    $[18] = T0;
    $[19] = t5;
    $[20] = t7;
    $[21] = title;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}